module.exports = __webpack_public_path__ + "img/appAsset-flag--BR.ee0dba6a.svg";